import store from '../store'
// import { router } from "../app";

const RegisterRouteNames = {
  CREATE_ACCOUNT: 'register',
  CREATE_PROFILE: 'register-create-profile',
  JEDI_PLEDGE: 'register-jedi-pledge',
}

const RegisterRouteTitles = {
  [RegisterRouteNames.CREATE_ACCOUNT]: 'Create Account',
  [RegisterRouteNames.CREATE_PROFILE]: 'Create Profile',
  [RegisterRouteNames.JEDI_PLEDGE]: 'J.E.D.I. Pledge',
}


export const registrationRouteHelper = {
  evaluate() {
    if (!store.state.users.user.registration) {
      return RegisterRouteNames.CREATE_ACCOUNT;
    }

    let correctRouteName = RegisterRouteNames.CREATE_ACCOUNT;

    const { completedAccount, completedProfile, completedJedi } = store.state.users.user.registration;

    if (completedAccount && !completedProfile) {
      correctRouteName = RegisterRouteNames.CREATE_PROFILE;
    }

    if (completedAccount && completedProfile && !completedJedi) {
      correctRouteName = RegisterRouteNames.JEDI_PLEDGE;
    }

    if (completedAccount && completedProfile && completedJedi) {
      correctRouteName = 'Dashboard';
    }

    return correctRouteName;
  },
  outsideRegisterPage() {
    const user = store.state.users.user;

    if (user && user.registration) {
      const { completedProfile, completedJedi } = user.registration;

      if (!completedProfile) {
        return RegisterRouteNames.CREATE_PROFILE;
      }

      if (!completedJedi) {
        return RegisterRouteNames.JEDI_PLEDGE;
      }
    }

    return false;
  },
  pageTitle(currentRouteName) {
    if (RegisterRouteTitles.hasOwnProperty(currentRouteName)) {
      return RegisterRouteTitles[currentRouteName];
    }

    return 'Register'
  }
}